<script>
export default {
  name: 'has-filters',
  data () {
    return {
      initialFilterValues: {}
    };
  },
  computed: {
    filtersStorageKey () {
      return `blonie-crm-filters:${this.$route.path}`;
    }
  },
  beforeMount () {
    if (this.filters) {
      this.initialFilterValues = JSON.parse(JSON.stringify(this.filters));
      this.loadFilters();
    }
  },
  mounted () {
    this.$bus.$on('view-filters-save', this.saveFilters);
    this.$bus.$on('view-filters-reset', this.resetFilters);
  },
  methods: {
    loadFilters () {
      const stored = localStorage.getItem(this.filtersStorageKey);
      if (stored) {
        this.filters = JSON.parse(stored);
        return;
      }

      this.resetFilters();
    },
    saveFilters () {
      localStorage.setItem(this.filtersStorageKey, JSON.stringify(this.filters));
    },
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.initialFilterValues));
      this.saveFilters();
    }
  },
  beforeDestroy () {
    this.$bus.$off('view-filters-save', this.saveFilters);
    this.$bus.$off('view-filters-reset', this.resetFilters);
  }
}
</script>
